module.exports = __webpack_public_path__ + "static/media/yunying7.1822587d.jpg";